/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosResponse } from "axios";
import { ReactElement } from "react";
import ErrorCode from "../../common/errorCode";
import { ProblemDetails } from "../../common/problemDetails";
import HttpStatusCode from "../../common/httpStatusCode";
import { handledErrorCodes } from "../../utils/errorUtils";
import FetchResponseException from "../../infrastructure/exceptions/FetchResponseException";
import GeneralErrorPage from "../../layout/Errors/GeneralErrorPage";

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: (...args: Array<unknown>) => void;
}

/*
 * ErrorFallback component to handle errors
 */
const ErrorFallback = ({ error }: ErrorFallbackProps): ReactElement => {
  if (error instanceof FetchResponseException) {
    return <GeneralErrorPage errorMessage={error.message} />;
  }
  if (axios.isAxiosError(error)) {
    const response = error.response as AxiosResponse<ProblemDetails>;
    if (!response) {
      return (
        <GeneralErrorPage
          errorMessage={`We encountered a ${ErrorCode.Unknown.toString()} error while processing your request.`}
        />
      );
    }

    switch (response.status) {
      case HttpStatusCode.Unauthorized:
      case HttpStatusCode.NotFound:
      case HttpStatusCode.BadGateway:
      case HttpStatusCode.ServiceUnavailable:
        return (
          <GeneralErrorPage
            errorMessage={`We encountered a ${response.status.toString()} error while processing your request.`}
          />
        );

      case HttpStatusCode.Forbidden: {
        const errorCode = handledErrorCodes.includes(response.data.errorCode)
          ? response.data.errorCode.toString()
          : response.status.toString();

        return <GeneralErrorPage errorMessage={`We encountered a ${errorCode} error while processing your request.`} />;
      }

      default:
        return (
          <GeneralErrorPage
            errorMessage={`We encountered a ${ErrorCode.Unknown.toString()} error while processing your request.`}
          />
        );
    }
  }
  return <GeneralErrorPage errorMessage='We encountered an error while processing your request.' />;
};

export default ErrorFallback;
